var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChampionshipsCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53333 12.6334H4.66667C4.05383 12.6334 3.447 12.5127 2.88081 12.2782C2.31462 12.0436 1.80018 11.6999 1.36683 11.2665C0.491665 10.3914 0 9.20439 0 7.96672V4.23338C0 3.98585 0.098333 3.74845 0.273367 3.57342C0.448401 3.39838 0.685798 3.30005 0.933333 3.30005H6.53333V5.16672H1.86667V7.96672C1.86667 8.70932 2.16167 9.42151 2.68677 9.94661C3.21187 10.4717 3.92406 10.7667 4.66667 10.7667H6.53333V12.6334Z",
    fill: "url(#paint0_linear_149_3455)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3332 12.6334H21.4666V10.7667H23.3332C24.0758 10.7667 24.788 10.4717 25.3131 9.94661C25.8382 9.42151 26.1332 8.70932 26.1332 7.96672V5.16672H21.4666V3.30005H27.0666C27.3141 3.30005 27.5515 3.39838 27.7265 3.57342C27.9016 3.74845 27.9999 3.98585 27.9999 4.23338V7.96672C27.9999 8.57955 27.8792 9.18638 27.6447 9.75257C27.4101 10.3188 27.0664 10.8332 26.6331 11.2665C26.1997 11.6999 25.6853 12.0436 25.1191 12.2782C24.5529 12.5127 23.9461 12.6334 23.3332 12.6334Z",
    fill: "url(#paint1_linear_149_3455)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 16.2547C16.7725 16.0271 16.6622 15.8175 16.49 15.666C16.3179 15.5145 16.096 15.4317 15.8667 15.4334H12.1333C11.904 15.4317 11.6822 15.5145 11.51 15.666C11.3379 15.8175 11.2275 16.0271 11.2 16.2547L10.2667 23.7214C10.2507 23.8516 10.2624 23.9838 10.301 24.1093C10.3396 24.2347 10.4043 24.3506 10.4907 24.4494C10.5792 24.5501 10.6883 24.6306 10.8108 24.6854C10.9332 24.7401 11.0659 24.7679 11.2 24.7667H16.8C16.9325 24.7665 17.0635 24.7382 17.1842 24.6834C17.3049 24.6287 17.4126 24.5489 17.5 24.4494C17.5864 24.3506 17.6511 24.2347 17.6897 24.1093C17.7283 23.9838 17.74 23.8516 17.724 23.7214L16.8 16.2547Z",
    fill: "url(#paint2_linear_149_3455)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4666 0.5H6.53328C6.28575 0.5 6.04835 0.598333 5.87332 0.773367C5.69828 0.948401 5.59995 1.1858 5.59995 1.43333V11.7C5.59821 11.8183 5.62043 11.9358 5.66528 12.0453L7.06528 15.536C7.27218 16.0555 7.62989 16.5012 8.09233 16.8156C8.55477 17.1299 9.10076 17.2987 9.65995 17.3H18.3399C18.8991 17.2987 19.4451 17.1299 19.9076 16.8156C20.37 16.5012 20.7277 16.0555 20.9346 15.536L22.3346 12.0453C22.3795 11.9358 22.4017 11.8183 22.3999 11.7V1.43333C22.3999 1.1858 22.3016 0.948401 22.1266 0.773367C21.9515 0.598333 21.7141 0.5 21.4666 0.5Z",
    fill: "url(#paint3_linear_149_3455)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6001 22.9H8.4001C7.65749 22.9 6.9453 23.195 6.4202 23.7201C5.8951 24.2452 5.6001 24.9574 5.6001 25.7V27.5667C5.6001 27.8142 5.69843 28.0516 5.87346 28.2267C6.0485 28.4017 6.2859 28.5 6.53343 28.5H21.4668C21.7143 28.5 21.9517 28.4017 22.1267 28.2267C22.3018 28.0516 22.4001 27.8142 22.4001 27.5667V25.7C22.4001 24.9574 22.1051 24.2452 21.58 23.7201C21.0549 23.195 20.3427 22.9 19.6001 22.9Z",
    fill: "url(#paint4_linear_149_3455)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_149_3455",
    x1: 7.10754e-8,
    y1: 3.96671,
    x2: 6.6679,
    y2: 4.08832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_149_3455",
    x1: 21.4666,
    y1: 3.96671,
    x2: 28.1345,
    y2: 4.08832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_149_3455",
    x1: 10.2598,
    y1: 16.1,
    x2: 17.884,
    y2: 16.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_149_3455",
    x1: 5.59985,
    y1: 1.69999,
    x2: 22.7401,
    y2: 2.14658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_149_3455",
    x1: 5.6001,
    y1: 23.3,
    x2: 22.6477,
    y2: 24.6325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampionshipsCount);
export default __webpack_public_path__ + "static/media/championships_count.271067e9877a3db10a185acb9955cedf.svg";
export { ForwardRef as ReactComponent };